<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
/**
 * Report component
 */
export default {
    components: { Layout, PageHeader, VueLoading },
    data() {
        return {
            tableData: [],
            title: "Report",
            items: [
                {
                    text: "Log Viewer",
                    href: "/",
                },
                {
                    text: "Report",
                    active: true,
                },
            ],
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 25, 50, 100],
            sdType: "",
            sdTypeList: [
                { value: "", text: "全て" },
                { value: "0", text: "一般" },
                { value: "1", text: "病理" },
            ],
            dateType: "U",
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
            hospno: "",
            logSets: "",
            logItems: "",
            filter: null,
            filterOn: [],
            fields: [
                { key: "SDTYPE", sortable: false, tdClass: "minWidth100" },
                { key: "SID", sortable: false, tdClass: "minWidth100" },
                { key: "UDATE", sortable: false, tdClass: "minWidth100" },
                { key: "RDATE", sortable: false, tdClass: "minWidth100" },
                { key: "HOSPNO", sortable: false, tdClass: "minWidth100" },
                { key: "HOSPNAME", sortable: false, tdClass: "minWidth200" },
                { key: "KNAME", sortable: false, tdClass: "minWidth100" },
                { key: "PNAME", sortable: false, tdClass: "minWidth100" },
                { key: "KARTENO", sortable: false, tdClass: "minWidth100" },
                { key: "SETS", sortable: false, tdClass: "minWidth300" },
                { key: "ITEMS", sortable: false, tdClass: "minWidth300" },
                { key: "RepCat", sortable: false, tdClass: "minWidth100" },
                { key: "SETCOUNT", sortable: false, tdClass: "minWidth100" },
                { key: "ITEMCOUNT", sortable: false, tdClass: "minWidth100" },
                { key: "FinalRep", sortable: false, tdClass: "minWidth100" },
                { key: "OrderAdded", sortable: false, tdClass: "minWidth200" },
                { key: "VCPlusLOG", sortable: false, tdClass: "minWidth200" },
                { key: "MailLOG", sortable: false, tdClass: "minWidth200" },
                { key: "FAXLOG", sortable: false, tdClass: "minWidth200" },
                { key: "PrintLOG", sortable: false, tdClass: "minWidth200" },
                { key: "HW", sortable: false, tdClass: "minWidth100" },
                { key: "SENDMDP", sortable: false, tdClass: "minWidth100" },
            ],
            loading: false,
        };
    },
    validations: {},
    mounted() {
        this.getUser("user");
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        search() {
            this.loading = true;
            axios
                .get(
                    "/api/report" +
                        "?sdtype=" +
                        this.sdType +
                        "&dateType=" +
                        this.dateType +
                        "&startDate=" +
                        this.startDate +
                        "&endDate=" +
                        this.endDate +
                        "&startTime=" +
                        this.startTime +
                        "&endTime=" +
                        this.endTime +
                        "&hospno=" +
                        this.hospno +
                        "&sets=" +
                        this.logSets +
                        "&items=" +
                        this.logItems
                )
                .then((response) => {
                    this.loading = false;
                    this.tableData = response.data;
                    if (this.tableData.length > 1000) {
                        this.tableData.pop();
                        this.$toasted.success(
                            "件数が多いため、上位" +
                                this.tableData.length.toString(10) +
                                "件まで表示します"
                        );
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.errorProcess(error);
                });
        },
    },
};
</script>
<style>
.minWidth100 {
    min-width: 100px;
}
.minWidth200 {
    min-width: 200px;
}
.minWidth300 {
    min-width: 300px;
}
.modal-mask {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="SDTYPE"
                                    label-for="select"
                                >
                                    <b-form-select
                                        for="select"
                                        v-model="sdType"
                                        class="form-select ms-2"
                                        :options="sdTypeList"
                                        style="width: 100px"
                                    ></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-9"></div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-3">
                                <b-form-group>
                                    <div
                                        class="form-check form-check-inline mt-2"
                                    >
                                        <b-form-radio
                                            v-model="dateType"
                                            value="U"
                                            plain
                                            >受付日</b-form-radio
                                        >
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <b-form-radio
                                            v-model="dateType"
                                            value="R"
                                            plain
                                            >報告日</b-form-radio
                                        >
                                    </div>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="開始日付"
                                    label-for="start_date"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        id="start_date"
                                        v-model="startDate"
                                        type="date"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="終了日付"
                                    label-for="end_date"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        id="end_date"
                                        v-model="endDate"
                                        type="date"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3"></div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-3"></div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="受付開始時刻"
                                    label-for="start_time"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        id="start_time"
                                        v-model="startTime"
                                        type="time"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="受付終了時刻"
                                    label-for="end_time"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        id="end_time"
                                        v-model="endTime"
                                        type="time"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3"></div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="HOSPNO"
                                    label-for="hospno"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        for="hospno"
                                        v-model="hospno"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="SETS"
                                    label-for="logSets"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        for="logSets"
                                        v-model="logSets"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <b-form-group
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    label="ITEMS"
                                    label-for="logItems"
                                >
                                    <b-form-input
                                        class="ms-2"
                                        for="logItems"
                                        v-model="logItems"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-sm-12 col-md-3"></div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-12">
                                <div
                                    id="tickets-table_filter"
                                    class="text-md-end"
                                >
                                    <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="search"
                                    >
                                        検索
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row mt-3">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                        style="white-space: nowrap"
                                    >
                                        表示&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            class="form-select form-select-sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;行
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div class="text-md-end">
                                    <label
                                        class="d-inline-flex align-items-center"
                                        style="white-space: nowrap"
                                    >
                                        フィルタ:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                striped
                                hover
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                            ></b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="dataTables_paginate paging_simple_numbers float-end"
                                >
                                    <ul
                                        class="pagination pagination-rounded mb-0"
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
        <div v-if="loading" class="modal-mask">
            <vue-loading
                type="spiningDubbles"
                color="#eee"
                :size="{ width: '50px', height: '50px' }"
            ></vue-loading>
        </div>
    </Layout>
</template>
